<template>
  <form class="search-form" @submit.prevent="search">
    <div class="input-group">
      <input :id="inputId" v-model="query" type="text" class="form-control" :class="{[inputClass]: true}" name="query"
             :placeholder="placeholderText">
      <div>
        <slot name="search-button" />
      </div>
    </div>
  </form>
</template>

<script>
import { searchBarMixin } from '../location-search/search-bar-mixin'
export default {
  mixins: [ searchBarMixin ]
}
</script>

<style lang="scss" scoped>
.search-form {
  background-color: transparent;
}

.input-group {
  display: flex;
  width: 100%;

  input {
    flex: 1;
  }

  .form-control, ::v-deep(.btn) {
    height: 50px;
    z-index: unset;
  }
}
</style>
